import { render, staticRenderFns } from "./AlertVar.vue?vue&type=template&id=04c81c3c&scoped=true&"
import script from "./AlertVar.vue?vue&type=script&lang=ts&"
export * from "./AlertVar.vue?vue&type=script&lang=ts&"
import style0 from "./AlertVar.vue?vue&type=style&index=0&id=04c81c3c&lans=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c81c3c",
  null
  
)

export default component.exports